import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InsightsIcon from '@mui/icons-material/Insights';
import StarIcon from '@mui/icons-material/Star';
import {  AlertTitle, Box, Button, Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import { styled, Theme, useMediaQuery } from '@mui/system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { gotoLogin } from '@/features/Functions/ResultFunctions';

interface PremiumAlertProps {
  title?: React.ReactNode;
  features?: { label: React.ReactNode; description: React.ReactNode; icon?: React.ReactNode }[];
}

// Fix scrolling issue by setting strict height, removing padding, and using flexbox
const PremiumAlertContainer = styled(Alert)(({ theme }) => ({
  height: '20vh', // Strict height
  padding: theme.spacing(1.5), // Add a bit of padding
  borderRadius: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden', // Prevent scrolling
}));

const HeaderContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem', // Spacing between icon and text
  width: '100%',
  justifyContent: 'flex-start',
});

const StyledList = styled('ul')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '0.1rem',
});
const StyledButton = styled(Button)({
  background: 'linear-gradient(to right, #0EAEC1, #0077B6)',
  color: '#FFFFFF',
  fontWeight: 'bold',
  padding: '0.2rem 4rem',
  borderRadius: '0.5rem',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    opacity: 0.9,
  },
});
const StyledListItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.2rem',
  padding: '0.1rem ',
});


const SmallPremiumAlert: React.FC<PremiumAlertProps> = ({
                                                          title = 'Premium Features',
                                                          features = [
                                                            { label: 'Custom Tone', description: 'Create your own custom tone.', icon: <StarIcon fontSize="small" color="warning" /> },
                                                            { label: 'Use GPT-4o', description: 'Unlock better results.', icon: <InfoOutlinedIcon fontSize="small" color="info" /> },
                                                            { label: 'Use ScoreFlash', description: 'Get content insights.', icon: <InsightsIcon fontSize="small" color="success" /> },
                                                          ],
                                                        }) => {
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Alert  icon={false} sx={{width: '100%' , justifyContent: 'center'}}>
      {/* Title next to the alert icon */}
      {/*<HeaderContainer>*/}
      {/*  <AlertTitle>{title}</AlertTitle>*/}
      {/*</HeaderContainer>*/}
      {!isSmallScreen &&
      <StyledList>
        {features.map((feature, index) => (
          <StyledListItem key={index}>
            {feature.icon}
            <Typography variant="body2">
              <strong>{feature.label}: </strong> {feature.description}
            </Typography>
          </StyledListItem>
        ))}
      </StyledList>
      }
      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <StyledButton variant="text" onClick={(e) => {
          e.preventDefault();  // Prevent the default behavior
          gotoLogin();         // Call the gotoLogin function
        }}>
          <FormattedMessage id="home.text-generator.signupnow" />
        </StyledButton>
      </Box>
    </Alert>
  );
};

export default SmallPremiumAlert;
